import { request } from '@/utils/utils.js'

let mixin = {
  data () {
    return {

    }
  },
  mounted () {
    // this.getUrlToFile()
  },
  methods: {
    kycUploadFiles (files, callback) {
      let token = localStorage.getItem('Authorization')
      const formdata = new FormData()
      for (let i = 0; i < files.length; i++) {
        formdata.append('files', files[i])
      }
      this.loadingFullScreen('Uploading', 'Uploading', 'fa fa-hourglass-half')
      request({
        method: 'POST',
        url: `api/dashboard/merchant/kyc/uploadfiles?access_token=${token}`,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        data: formdata
      }).then(res => {
        if (!res) {
          return
        }
        let data = res.data
        this.Uploading.close()
        if (data.code === '10000') {
          // this.$message({
          //   type: 'success',
          //   message: 'Upload success'
          // })
          callback && callback(data.data.urlList)
        } else {
          this.$message({
            type: 'warn',
            message: 'Upload fail'
          })
        }
      }).catch(() => {
        this.Uploading.close()
        // this.$message({
        //   type: 'warn',
        //   message: 'fail'
        // })
      })
    },
    getMerchantKYCInfo (page, callback) {
      this.loadingFullScreen('getMerchantKYCInfoLoading', 'Loading', 'fa fa-hourglass-half')
      let token = localStorage.getItem('Authorization')
      request({
        method: 'POST',
        url: `api/dashboard/merchant/kyc/getMerchantKYCInfo?access_token=${token}&page=${page}`,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }).then(res => {
        this.getMerchantKYCInfoLoading.close()
        if (!res) {
          return
        }
        let data = res.data
        if (data.code === '10000') {
          callback && callback(data.data)
        } else {
          this.$message({
            type: 'warn',
            message: 'Get merchantKYCInfo fail'
          })
        }
      }).catch(() => {
        this.getMerchantKYCInfoLoading.close()
        this.$message({
          type: 'warn',
          message: 'fail'
        })
      })
    },
    // getUrlToFile (urls) {
    //   // eslint-disable-next-line no-useless-return
    //   if (!urls) return
    //   let files = []
    //   urls.forEach((url) => {
    //     let lastNameIndex = url.lastIndexOf('/') + 1
    //     let fileName = url.substring(lastNameIndex)
    //     let lastTypeIndex = url.lastIndexOf('.') + 1
    //     let fileType = url.substring(lastTypeIndex)
    //     // console.log('fileName', fileName)
    //     let file = {
    //       url: url,
    //       name: fileName,
    //       type: fileType,
    //       image: url,
    //       size: this.formatSize(file.size),
    //       date: this.formatDate(new Date()),
    //     }
    //     files.push(file)
    //   })
    //   // console.log('files', files)
    //   return files
    // },
    loadingFullScreen (controller, txt, className) {
      this[controller] = this.$loading({
        lock: true,
        text: txt,
        spinner: className,
        background: 'rgba(0, 0, 0, 0.7)',
      })
    },
  }
}

export default mixin
